import React from "react";
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

export default class RoundedLink extends React.PureComponent {
    render() {
        let { link, text, className, isBlank } = this.props;

        if (isBlank) {
            return (
                <a className={'rounded-link'} href={link} target={'_blank'} rel={'noopener noreferrer'}>
                    <span className={className}>{text}</span>
                </a>
            )
        }
        return (
            <NavLink
                to={link}
                className={'rounded-link'}>
                <span className={className}>{text}</span>
            </NavLink>
        );
    }
}

RoundedLink.propTypes = {
    text: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    className: PropTypes.string,
    isBlank: PropTypes.bool,
};
